import validate from "validate.js";

const regex = (value, options) => {
  const regExp = new RegExp(options.pattern); //not used for now

  if (!regExp.test(value)) {
    return options.message;
  }
};

const checked = (value, options) => {
  if (value !== true) {
    return options.message || "must be checked";
  }
};
//eslint-disable-next-line
validate.validators.email.PATTERN =
  /^(?!.*\.\.)[A-Za-z0-9#!%$'&+*\-/=?^_`{|}~][A-Za-z0-9#!%$'&+*\-/=?^_`.{|}~]{0,63}@(?!-)(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,62}[A-Za-z0-9])?\.)*(?!\d+\.)(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,62}[A-Za-z0-9])?\.)(?!-)([A-Za-z][A-Za-z0-9-]{1,62}[A-Za-z0-9]|[A-Za-z]{2,})(?<![-.])$/;
validate.validators.email.message = "is not valid.";

const passwordRegex = /^[a-zA-Z0-9#!%$'&+*-/=?^_`.|{}~]{4,24}$/;
const passwordValidationErrorMessage = "is not valid";

const optionalEmail = (value) => {
  if (value === "") {
    return null;
  }
  return validate.single(value, { email: true });
};

const validatePassword = (value, options) => {
  const regexPattern = options.pattern || passwordRegex;
  if (!regexPattern.test(value)) {
    return options.message || passwordValidationErrorMessage;
  }
};

validate.validators = {
  ...validate.validators,
  regex,
  checked,
  optionalEmail,
  validatePassword,
};
